export const CALENDAR_VIEW_NO_TASK_TYPES_COUNT = 0

export const QA_NAME_CALENDAR_NO_TASK_TYPES = 'calendarNoTaskTypes'
